import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMerge = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.12478 3C1.50264 3 1 3.50264 1 4.12478C1 4.74692 1.50264 5.24956 2.12478 5.24956H5.5413C5.88225 5.24956 6.20562 5.40422 6.42004 5.67135L9.6819 9.74868L6.42004 13.826C6.20562 14.0931 5.88225 14.2478 5.5413 14.2478H2.12478C1.50264 14.2478 1 14.7504 1 15.3726C1 15.9947 1.50264 16.4974 2.12478 16.4974H5.5413C6.56766 16.4974 7.53427 16.0299 8.17751 15.232L11.6643 10.8735H14.4974V11.9982C14.4974 12.4517 14.7715 12.8629 15.1933 13.0387C15.6151 13.2144 16.0967 13.116 16.42 12.7961L18.6696 10.5466C18.8805 10.3357 19 10.051 19 9.7522C19 9.45343 18.8805 9.16872 18.6696 8.95782L16.42 6.70826C16.0967 6.38489 15.6151 6.28998 15.1933 6.46573C14.7715 6.64148 14.4974 7.04921 14.4974 7.50615V8.63093H11.6643L8.17751 4.26538C7.53779 3.46397 6.56766 3 5.5413 3H2.12478Z",
		fill: "#0D2976"
	})
});
export default SvgMerge;
